import { apiGet, apiPost, apiPut } from "utils/apiClient";
import type { MobileNotificationSettings } from "types/MobileNotificationSettings";

export async function fetchMobileNotificationSettings(token: string): Promise<MobileNotificationSettings> {
    return apiGet<MobileNotificationSettings>("/mobile/notification-settings", token);
}

export async function saveMobileNotificationSettings(
    token: string,
    patch: Partial<MobileNotificationSettings>,
): Promise<MobileNotificationSettings> {
    return apiPut<MobileNotificationSettings>("/mobile/notification-settings", patch, token);
}

export async function registerMobileDevice(
    token: string,
    payload: { platform: "android" | "ios"; pushToken: string; deviceId: string; appVersion?: string },
): Promise<void> {
    await apiPost("/mobile/devices/register", payload, token);
}

export async function unregisterMobileDevice(token: string, deviceId: string): Promise<void> {
    await apiPost("/mobile/devices/unregister", { deviceId }, token);
}
